import { GitBranch01Icon } from '@langchain/untitled-ui-icons';

import { useContext } from 'react';

import { IconButton } from '@/design-system';
import { useRun } from '@/hooks/useSwr.tsx';

import { USE_RUN_OPTIONS } from '../../../constants';
import { TraceLog } from '../../../data/misc';
import {
  StudioRenderMode,
  StudioRenderModeContext,
} from '../../../hooks/useStudioRenderMode';
import { GraphDatasetContext } from '../dataset/GraphDatasetProvider';

const GraphTraceLogRowRunTags = (props: { runId: string | null }) => {
  const run = useRun({
    id: props.runId,
    shareToken: undefined,
    options: USE_RUN_OPTIONS(10),
  });
  const { setRenderMode } = useContext(StudioRenderModeContext);

  const datasetState = useContext(GraphDatasetContext);
  if (datasetState.isAddingToDataset) return null;
  if (!run.data) return null;
  return (
    <IconButton
      icon={GitBranch01Icon}
      label="Open LangSmith trace"
      tooltipProps={{
        side: 'bottom',
      }}
      className="h-[24px] w-[24px]"
      variant="outlined"
      color="secondary"
      onClick={() => setRenderMode(StudioRenderMode.TRACE)}
    />
  );
};

export const GraphTraceLogRowSmith = (props: { traceLog: TraceLog }) => {
  if (!props.traceLog.meta.runId) return null;
  return <GraphTraceLogRowRunTags runId={props.traceLog.meta.runId} />;
};
